



const ProjetDiscussions = () => {
  return (
    <div>ProjetDiscussions</div>
  )
}

export default ProjetDiscussions